<template>
    <div>
      <el-drawer @reload="$reloadHandle"
                 :title="'上传发票'" size="30%"
                 :before-close="handleClose"
                 :visible.sync="drawer"
                 direction="rtl"
                 :modal-append-to-body="true"
                 custom-class="demo-drawer"
                 ref="drawer"
      >

        <div class="demo-drawer__content">
            <el-form :model="formData">
                <el-form-item label="发票号">
                    <el-input placeholder="请输入发票号" v-model="formData.invoiceNo" style="width: 150px;"></el-input>
                </el-form-item>
            </el-form>
            <el-form :model="formData">
                <el-form-item label="发票金额">
                    <el-input placeholder="请输入发票金额" v-model="formData.invoiceNoAmount" style="width: 150px;"></el-input>
                </el-form-item>
            </el-form>
          <!-- <el-form :model="formData">
            <el-form-item label="调整原因">
              <el-input type="textarea"
                        :autosize="{ minRows: 4, maxRows: 8}"
                        v-model="formData.adjustReason"
                        autocomplete="off"
              ></el-input>
            </el-form-item>
          </el-form> -->
          <el-form :model="formData">
            <el-form-item label="发票图片">
                <!-- <div class="pic_3"> -->
                  <!-- <div class="pic3_title">发票图片:</div> -->
                  <!-- <el-upload style="display:flex;align-items: center;"
																:action="api.uploadFileUrl" :on-remove="handleRemove1"
																list-type="picture-card" :file-list="picList1"
																:on-success="(res, file, fileList) => { handleSuccess1(res, file, fileList) }"
																:on-change="(files, fileList) => { handleImageChange(fileList) }"
																:auto-upload="true" :on-preview="handlePictureCardPreview"
																:headers="headers">
																<i slot="default" class="el-icon-plus"></i>
															</el-upload> -->
                              <pdfUpload :photo-url.sync="formData.invoicePicList"/>
                <!-- </div> -->
            </el-form-item>
            <el-form-item label="文件压缩包">
                              <textUpload :photo-url.sync="documentBook"/>
            </el-form-item>

          </el-form>

        <div class="demo-drawer__footer" style="position: absolute;
            bottom: 5px; right: 5px;">
            <el-button @click="cancelForm">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
          </div>
        </div>
      </el-drawer>
      <el-image-viewer v-if="dialogVisible" :on-close="closeImgViewer" :url-list="dialogImageUrlList"
			style="z-index: 3000!important;" />
    </div>
  </template>
  <script>
import store from "@/store";

  import api from "@/api/projectApi";
import { echoFileFormat, uploadFileFormat } from "@/util/uploadFormat";
  // 图片组件
import photoUpload from "@/components/formItem/photoUpload.vue"
// 文件上传
import textUpload from "@/components/formItem/textUpload.vue"
// pdf上传
import pdfUpload from "@/components/formItem/pdfUpload.vue"
  export default {
    inject: ['reload'],
    name: 'edit',
    props: ['ids','invoiceNo','invoiceNoAmount','invoicePic'],
    components: {
      pdfUpload,
      textUpload,
      photoUpload,
		'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
	},
    created() {
      console.log('批量上传发票id', this.ids)
      this.formData.ids = this.ids
      this.formData.invoiceNo = this.invoiceNo
      this.formData.invoiceNoAmount = this.invoiceNoAmount
      this.formData.invoicePic = this.invoicePic
    },
    watch: {
		picList1: {
			handler(newVal, oldVal) {
				this.formData.invoicePic = uploadFileFormat(newVal)
				console.log(this.formData)
			},
			deep: true, // 加这个属性，深度监听
		},

		file: {
			handler(newVal, oldVal) {
				this.formData.snSiteInfoDTO.contractFile = uploadFileFormat(newVal)
			},
			deep: true, // 加这个属性，深度监听
		},
	},
    computed: {
		api() {
			return api
		},
		headers: function () {
			const tenantId = store.getters.userInfo.tenantId
			return {
				'Authorization': "Bearer " + store.getters.access_token,
				'TENANT-ID': tenantId
			};
		}
	},
    data() {
      return {
      documentBook:[{url:'',name:''}],

        file: [],
        dialogImageUrl: '',
        dialogImageUrlList: [],
        dialogVisible: false,
        uploadDisabled: false,
        formData: {
          invoicePic:'',
          invoiceNo: null,
          invoiceNoAmount: null,
          invoicePicList:[],
          remark: null,
          ids: [],
          type: null,
        },
        drawer: true,
      }
    },
    methods: {
      closeImgViewer() {
			this.dialogVisible = false
		},
		//点击查看图片
		handlePictureCardPreview(file) {
			this.dialogImageUrlList = [file.url]
			this.dialogVisible = true;
			// console.log(fileList, "已上传文件")
		},
		handleImageChange(fileList) {
			if (fileList.length > 1) {
				fileList.splice(0, 1);
			}
		},

      // 确定
      confirm() {
        console.log( this.formData.invoicePicList,"5-PDF的信息");

        console.log( this.documentBook,"文档的信息");
         this.formData.zipUrl=this.documentBook[0].url  ? this.documentBook[0].url : "",//文件URL
         this.formData.zipName =this.documentBook!=="" ? this.documentBook[0].name : "",//文件名
          this.$http({
            url: api.sfBatchSettle.batchUploadInvoiceDataUrl,
            method: 'post',
            data: this.formData
          }).then(res => {
            this.$message.success('操作成功')
            this.visiable = false
            this.$emit('update:visiable', this.visiable)
            this.$emit('goBackIndex')
          })
      },

      // 上传成功
      handleSuccess4(res, file, fileList) {
        // 上传成功后，隐藏上传按钮
        this.upload_btn = true;
        console.log(res.data.url,"url")
        this.company.picList =[
            {url: res.data.url}
        ]
    },
      handleRemove4(response, file, fileList) {
        // 删除成功后，显示上传按钮
        // this.company.picList=[]
        this.upload_btn = false;
        // console.log(this.company.picList,"this.company.picList删除后");
    },

      cancelForm() {
        console.log( this.formData.invoicePicList,"5-PDF的信息");

console.log( this.documentBook,"文档的信息");
 this.formData.zipUrl=this.documentBook[0].url  ? this.documentBook[0].url : "",//文件URL
 this.formData.zipName =this.documentBook!=="" ? this.documentBook[0].name : "",//文件名
        this.visiable = false
        this.$emit('update:visiable', this.visiable)
      },
      handleClose() {
        this.cancelForm()
      }
    }
  }
  </script>
  <style lang="scss" scoped>
  ::v-deep .el-drawer .el-drawer__body {
    padding: 0 16px;
    background-color: #fff;
    position: relative;
  }

  ::v-deep .el-drawer .el-drawer__header {
    background-color: #fff;
  }

  ::v-deep .el-drawer__container {
    position: relative;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    background: aliceblue;
    background-color: rgb(38 38 38 / 70%);
  }

  #containt .table-detail {
    border-collapse: collapse;
    font-size: 12px;
    border: 1px solid #ededed;
  }

  .btn {
    text-align: center;
  }
  ::v-deep .el-form-item .el-form-item__label {
    text-align: right;
    font-size: 12px;
    font-weight: 400;
    width: 100px;
}
::v-deep .el-upload--picture-card {
	// margin-top: 10px;
	width: 40px;
	height: 40px;
	line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
	display: inline-block;
	width: 80px;
	height: 80px;
	margin-right: 14px;
	border-radius: 2px;
	padding: 0 !important;
	border-color: #e8e8e8;
	margin-top: 0;
	margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
	width: 80px;
	height: 80px;
	padding: 0;
	position: inherit;
	cursor: pointer;
}
/* 推荐，实现简单 */
.el-upload-list__item.is-ready,.el-upload-list__item.is-uploading {
  display: none !important;
}

.pic_3{
  height: 100px;
  margin-top: 10px;
  display: flex;
  align-items: center;
  .pic3_title{
    font-size: 12px;
    font-weight: 400;
    color: #606266;
    margin-right: 10px;
  }
}
  </style>
